import { ChangeEvent, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/classNames.ts';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { formatCurrency } from '$/utils/formatCurrency.ts';
import { CheckboxInputProps } from '@/components/functional/CheckboxInput/CheckboxInput.tsx';

type SubscriptionPlanBlockProps = PropsWithClassName<{
  value: CheckboxInputProps['value'];
  perMonth: number;
  perYear?: number;
  save?: number;
  checked?: boolean;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  currency?: string;
  error?: boolean;
  disabled?: boolean;
}>;

const SubscriptionPlanBlock: FC<SubscriptionPlanBlockProps> = ({
  value,
  className,
  perMonth,
  perYear,
  save,
  checked,
  onChange,
  currency = 'EUR',
  error = false,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <div className="relative">
      {save ? (
        <div className="absolute bottom-full translate-y-1/2 left-1/2 -translate-x-1/2 z-10">
          <div className="bg-primary text-xs font-bold px-4 py-2 rounded-full whitespace-nowrap leading-normal">
            {t('subscriptionSelectPage.bestValue', { number: save })}
          </div>
        </div>
      ) : null}
      <label
        className={cn(
          'cursor-pointer w-full rounded-xl border bg-white px-8 py-6 flex justify-between items-center gap-4',
          {
            'border-primary': checked && !error && !disabled,
            'border-base-300': !checked && !error && !disabled,
            'border-error': error && !disabled,
            'opacity-50 cursor-not-allowed': disabled,
          },
          className
        )}
      >
        <p className="font-feature font-bold italic text-3.5xl text-primary">
          {perYear ? t('label.annual') : t('label.monthly')}
        </p>
        <div className="flex flex-col items-end shrink-0">
          <p className="text-2xl font-bold">
            {perYear
              ? formatCurrency(perYear, currency, {
                  digits: 2,
                  calculate: true,
                })
              : formatCurrency(perMonth, currency, { digits: 2, calculate: true })}
            <span className="text-base font-normal text-text-secondary">
              /{perYear ? t('label.year') : t('label.month')}
            </span>
          </p>
          {/*{perYear ? (*/}
          {/*  <p className="text-xs text-text-secondary">*/}
          {/*    {formatCurrency(perMonth, currency, {*/}
          {/*      digits: 2,*/}
          {/*      calculate: true,*/}
          {/*    })}*/}
          {/*    /{t('label.month')}*/}
          {/*  </p>*/}
          {/*) : null}*/}
        </div>
        <input
          disabled={disabled}
          className="hidden"
          type="checkbox"
          checked={checked}
          value={value}
          onChange={onChange}
        />
      </label>
    </div>
  );
};

export default SubscriptionPlanBlock;
